import { render, staticRenderFns } from "./pieSmall.vue?vue&type=template&id=4f4cce40&"
import script from "./pieSmall.vue?vue&type=script&lang=js&"
export * from "./pieSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports